module.exports = __webpack_public_path__ + "img/bookmark.b2bee1a3.svg";